import { MapPin, Phone, Mail, Navigation } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { HOURS } from "../i18n/translations";
import { Reveal, SectionHeading } from "../components/ui-bits";

export default function Contact() {
  const { t } = useLanguage();
  return (
    <main className="pt-32 pb-10">
      <section className="max-w-7xl mx-auto px-5" data-testid="contact-section">
        <SectionHeading eyebrow="Helios" title={t("contact.title")} sub={t("contact.sub")} />

        <div className="grid lg:grid-cols-2 gap-8 items-start">
          <div className="space-y-6">
            <Reveal>
              <div className="glass glow-card rounded-3xl p-8" data-testid="contact-details">
                <p className="font-disco text-3xl neon mb-6">Bowling Helios</p>
                <ul className="space-y-4 text-[#E2F1FF]">
                  <li className="flex gap-3 items-start">
                    <MapPin size={18} className="text-[#F0C971] shrink-0 mt-1" />
                    <span>
                      <a
                        href="https://www.google.com/maps?q=Gerheide+48,+2490+Balen,+Belgium"
                        target="_blank"
                        rel="noreferrer"
                        data-testid="contact-address"
                        className="hover:text-[#00F0FF] transition-colors underline decoration-[#F0C971]/40 underline-offset-4"
                      >
                        {t("contact.address")}
                      </a>
                      <span className="block mt-2 text-xs text-[#9db8d6]" data-testid="contact-map-links">
                        <a href="https://www.google.com/maps?q=Gerheide+48,+2490+Balen,+Belgium" target="_blank" rel="noreferrer" data-testid="map-google" className="hover:text-[#00F0FF] transition-colors underline underline-offset-2">Google Maps</a>
                        {" · "}
                        <a href="https://maps.apple.com/?q=Gerheide+48,+2490+Balen,+Belgium" target="_blank" rel="noreferrer" data-testid="map-apple" className="hover:text-[#00F0FF] transition-colors underline underline-offset-2">Apple Maps</a>
                        {" · "}
                        <a href="https://waze.com/ul?q=Gerheide%2048%2C%202490%20Balen%2C%20Belgium&navigate=yes" target="_blank" rel="noreferrer" data-testid="map-waze" className="hover:text-[#00F0FF] transition-colors underline underline-offset-2">Waze</a>
                      </span>
                    </span>
                  </li>
                  <li>
                    <a href="tel:+3214812093" data-testid="contact-phone" className="flex gap-3 items-center hover:text-[#00F0FF] transition-colors">
                      <Phone size={18} className="text-[#F0C971]" /> +32 (0)14 81 20 93
                    </a>
                  </li>
                  <li>
                    <a href="mailto:heliosbowling@gmail.com" data-testid="contact-email" className="flex gap-3 items-center hover:text-[#00F0FF] transition-colors">
                      <Mail size={18} className="text-[#F0C971]" /> heliosbowling@gmail.com
                    </a>
                  </li>
                </ul>
                <div className="mt-8 flex flex-col sm:flex-row gap-3">
                  <a href="tel:+3214812093" data-testid="contact-call-button" className="btn-neon font-display text-sm tracking-[0.2em] uppercase px-8 py-3 rounded-full text-center">
                    {t("contact.call")}
                  </a>
                  <a
                    href="https://www.google.com/maps?q=Gerheide+48,+2490+Balen,+Belgium"
                    target="_blank"
                    rel="noreferrer"
                    data-testid="contact-route-button"
                    className="btn-ghost font-display text-sm tracking-[0.2em] uppercase px-8 py-3 rounded-full inline-flex items-center gap-2 justify-center"
                  >
                    <Navigation size={15} /> {t("contact.route")}
                  </a>
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="glass rounded-3xl p-8" data-testid="contact-hours">
                <h3 className="font-display text-2xl uppercase tracking-widest neon mb-5">{t("hours.title")}</h3>
                <ul className="space-y-2.5 text-sm">
                  {HOURS.map((h) => (
                    <li key={h.day} className="flex justify-between gap-4 border-b border-[#00F0FF]/8 pb-2">
                      <span className="text-[#9db8d6]">{t(`hours.${h.day}`)}</span>
                      <span className={h.time ? "text-[#E2F1FF] font-semibold" : "text-[#F0C971] font-semibold"}>
                        {h.time || t("hours.closed")}
                      </span>
                    </li>
                  ))}
                </ul>
                <p className="mt-5 text-xs text-[#9db8d6]">{t("hours.groups")}</p>
                <p className="mt-2 text-xs text-[#F0C971]" data-testid="hours-holidays-note">{t("hours.holidays")}</p>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.15}>
            <div className="glass rounded-3xl overflow-hidden h-[540px]" data-testid="contact-map">
              <iframe
                title="Bowling Helios map"
                src="https://www.google.com/maps?q=Gerheide+48,+2490+Balen,+Belgium&output=embed"
                className="w-full h-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
